import type { JSX } from 'react'

import { TextBlockNotice } from 'blocks/TextBlock/Templates'
import { NoticeTextSC } from '../Footer.styled'

export interface INoticeText {
  noticeTitle?: string
  noticeDescription?: string
  dataTestId?: string
}

export const NoticeText = ({
  noticeTitle = '',
  noticeDescription = '',
  dataTestId = '',
}: INoticeText): JSX.Element => {
  return (
    <NoticeTextSC data-testid={dataTestId}>
      <TextBlockNotice title={noticeTitle} description={noticeDescription} />
    </NoticeTextSC>
  )
}
